import './Base'

/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

/**
 * @class
 * @extends UI.Widget.Forms.Control.Base
 */
UI.Widget.Forms.Control.Element = Class(UI.Widget.Forms.Control.Base, /** @lends UI.Widget.Forms.Control.Element.prototype */ {
    $element: null,
    $title: null,

    $: function (selector) {
        return this.$element.find(selector);
    },

    $name (name) {
        return this.$(`[name="${name}"]`)
    },

    bind: function() {
        this.createTitle();
        this.createElement();

        this.insertElement();
        this.insertTitle();

        this.applyAttributes();

        this.setMode(this.mode)

        this.ParentCall();
    },

    unbind: function() {
        this.removeTitle();
        this.removeElement();

        this.ParentCall();
    },

    update: function() {
        //this.updateElement(Util.coalesce(this.getValue(), this.$control.attr("def-value")));
		this.updateElement(this.getValue());

        this.ParentCall();
    },

    createTitle: function() {
        if(this.control.title) {
        	if (this.control.getAttribute('type') === 'checkbox') {
				this.$title = $("<span class='control-title inline'>").text(this.control.title);
			} else {
				this.$title = $("<span class='control-title'>").text(this.control.title);
			}
            if (this.required) {
                this.$title.addClass('required')
            }
        }
		if(this.control.getAttribute('sub-title')) {
			this.$title.append('<br>');
			this.$title.append("<small>"+this.control.getAttribute('sub-title')+"</small>");
		}
    },
    createElement: function() {
        this.$element = $("<span>");

        if (this.disabled) {
            this.$element.prop("disabled", true);
        }
    },

    insertTitle: function() {
        if(this.control.title) {
			if (this.control.getAttribute('type') === 'checkbox') {
				this.$title.insertAfter(this.$element);
			} else {
				this.$title.insertAfter(this.$control);
			}
		}
    },
    insertElement: function() {
        this.$element.insertAfter(this.$control);
    },
    updateElement: function(value) {
        this.$element.text(Util.isDefined(value) ? value : null);
    },

    removeElement: function() {
        this.$element?this.$element.remove():null;
        this.$element = null;
    },
    removeTitle: function () {
        this.$title?this.$title.remove():null;
        this.$title = null;

    },
    applyAttributes: function() {
        if (this.control) {
            var attributes = this.control.attributes;
            var regexp = /^html-(.*)$/;

            for (var i = 0, count = attributes.length; i < count; i++) {
                var attr = attributes[i].nodeName;
                var match;

                if (match = regexp.exec(attr)) {
                    var attribute = match[1];

                    this.$element.attr(attribute, this.$control.attr(attr));
                }
            }
        }
    },
    editMode () {
        this.ParentCall()
        this.$element && this.$element.prop('disabled', false)
    },
    viewMode () {
        this.ParentCall()
        this.$element && this.$element.prop('disabled', true)
    },
});
